import { createSelector } from "reselect";
import { AppState } from "state/store";
const selector = (state: AppState) => state.globalVariables;

export default createSelector([selector], (data) => data);